import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import SettingAndManagement from './components/SettingAndManagement';

const { Cell } = ResponsiveGrid;

const GroupBuyingSettingAndManagement = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="團購設定及管理"
        breadcrumbs={[
          {
            name: '團購管理',
          },
          {
            name: '團購設定及管理',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <SettingAndManagement />
    </Cell>
  </ResponsiveGrid>
);

export default GroupBuyingSettingAndManagement;
